import { IDeleteEntregaObraUseCase } from "../../../presentation/useCases/delete/delete_entrega_obra_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * DeleteEntregaObraUseCase
 */

export class DeleteEntregaObraUseCase implements IDeleteEntregaObraUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(idEntregaObra: number): Promise<void> {
    await this.repository.deleteEntregaObraById(idEntregaObra);
  }

}
